import React, { useState, useEffect, useRef } from 'react';
import './branches.css';
import Carousel from 'react-bootstrap/Carousel';
import 'react-multi-carousel/lib/styles.css';
import { Dialog } from 'primereact/dialog';
import { Col } from 'react-bootstrap';
import SecondaryBanner from '../banner/secondary-banner';
import { getBranch, imgBaseUrl2 } from '../../utils/api';
import CloseCollapse from '../../assets/icons/close.svg';
import LocationIcon from '../../assets/icons/branches/location.svg';
import CollapseIcon from '../../assets/icons/branches/collapse.svg';
import DefaultImage from '../../assets/images/defult-img.svg';
import MapComponent from '../MapComponent'; // Import the MapComponent for displaying location
import Loader from '../../components/loader/dotloader';
import { Paginator } from 'primereact/paginator'; // Import Paginator from primereact

const Branches = () => {
  const [branch, setBranch] = useState([]);
  const [long, setLong] = useState('');
  const [lat, setLat] = useState('');
  const [address, setAddress] = useState('');
  const [dialogContent, setDialogContent] = useState(null);
  const [visible, setVisible] = useState(false);
  const [mapVisible, setMapVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0); // State to track current page
  const itemsPerPage = 50; // Number of items per page
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [total, setTotal] = useState(0);
  const scrollTargetRef = useRef(null);
  // Fetch branch data from API  
  const fetchBranch = async (newPage = 0) => {
    try {
      setLoading(true);
      const pay = {
        pageIndex: 0,
        pageSize: 2000,
      };
      const res = await getBranch(pay);
      if (res.data.isSuccess) {
        // مرتب‌سازی بر اساس code
        const sortedBranches = res.data.data.items.sort((a, b) => a.code - b.code);

        setBranch(sortedBranches);
        setTotal(res.data.data.total);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching branch:', error);
    }
  };
  useEffect(() => {

    fetchBranch();
  }, []);
  // Handle page change
  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    setCurrentPage(Math.floor(event.first / event.rows));
    // اسکرول نرم به تگ هدف
    if (scrollTargetRef.current) {
      scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Open details dialog
  const openDialog = (branchItem) => {
    setDialogContent(branchItem);
    setVisible(true);
  };

  // Open map dialog
  const openMapDialog = (lat, long, addres) => {
    setLat(parseFloat(lat)); // Convert lat to a number
    setLong(parseFloat(long)); // Convert long to a number
    setAddress(addres);
    setMapVisible(true);
  };

  // Disable/Enable scroll when dialog is opened/closed
  useEffect(() => {
    if (visible || mapVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [visible, mapVisible]);

  const [isMobile, setIsMobile] = useState(false);

  // Detect if the user is on a mobile device
  useEffect(() => {
    setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
  }, []);

  // Open Google Maps for navigation on desktop
  const openMapNavigation = () => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${long}&travelmode=driving`;
    window.open(url, '_blank');
  };

  // Open Apple Maps for navigation (iOS only)
  const openAppleMaps = () => {
    const url = `maps://?daddr=${lat},${long}`;
    window.open(url, '_blank');
  };

  // Open the map for mobile or desktop
  const handleOpenMap = () => {
    if (isMobile) {
      if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')) {
        openAppleMaps(); // iOS device
      } else {
        openMapNavigation(); // Android device
      }
    } else {
      openMapNavigation(); // On desktop, open Google Maps in a new tab
    }
  };

  const getDefaultImage = (images) => {
    if (!images || images.length === 0) return DefaultImage;
    const defaultImg = images.find(img => img.isDefault);
    return defaultImg
      ? imgBaseUrl2 + 'io/300x300/' + defaultImg.url
      : imgBaseUrl2 + 'io/300x300/' + images[0].url;
  };
  // Get current page items
  const currentItems = branch.filter((product) => product.isActive === true).slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <div ref={scrollTargetRef}>
      {loading && <Loader isLoading={loading} />}

      {/* <div className='h-[200px] branch-banner'>
        <SecondaryBanner slug="branch1" />
      </div>

      <div >

      </div>

      {/* Details Dialog */}
      <Dialog
        visible={visible}
        style={{ width: '30vw' }}
        breakpoints={{ '1800px': '35vw', '1600px': '30vw', '1100px': '60vw', '900px': '60vw', '600px': '400vw', '500px': '95vw' }}
        onHide={() => setVisible(false)}
        className="custom-dialog"
      >
        <div>
          <Carousel
            indicators={dialogContent && dialogContent.images && dialogContent.images.length > 1}
            controls={dialogContent && dialogContent.images && dialogContent.images.length > 1}
          >
            {(dialogContent && dialogContent.images && dialogContent.images.length > 0
              ? dialogContent.images
              : [DefaultImage]
            ).map((image, index) => (
              <Carousel.Item key={index}>
                <div className="relative w-full aspect-[3/3] overflow-hidden rounded-lg">
                  <img
                    src={
                      imgBaseUrl2 + 'io/' + ((image && image.url) ? image.url : DefaultImage)
                    }
                    className="absolute top-0 left-0 w-full h-full object-cover"
                    alt="Branch"
                  />

                </div>
              </Carousel.Item>
            )
            )}
          </Carousel>

          <h4>{dialogContent && dialogContent.title ? dialogContent.title : 'Branch Title'}</h4>
          <p className="address-p text-center">{dialogContent && dialogContent.addres ? dialogContent.addres : ''}</p>
          <h6 className="text-center !text-[#00a14b] font-bold mt-0"><span className='text-[#333333]'>شماره داخلی:</span>  {dialogContent?.code}</h6>

          <div className='dailog-max-btn-right'></div>
          <div className='dailog-max-btn-left'></div>
          <div className='bg-modal'>
            <div className="dailog-max-btn">

              <button className="btn" onClick={() => setVisible(false)}>
                <img src={CloseCollapse} alt="Collapse" />
              </button>
            </div>
          </div>

        </div>
      </Dialog>

      {/* Map Dialog */}
      <Dialog
        visible={mapVisible}
        style={{ width: '40vw' }}
        breakpoints={{ '1800px': '45vw', '1600px': '40vw', '1100px': '75vw', '900px': '75vw', '600px': '400vw', '500px': '95vw' }}
        onHide={() => setMapVisible(false)}
        className="custom-dialog branch"
      >
        <MapComponent lat={lat} lng={long} />
        <div className="text-center">
          <p className="mt-3 map-addrres">{address}</p>
          <div className="w-100 text-center" style={{ marginBottom: '1em' }}>
            <button className="btn btn-primary mx-auto" onClick={handleOpenMap}>
              نمایش روی نقشه
            </button>
          </div>
        </div>
        <div className='dailog-max-btn-right'></div>
        <div className='dailog-max-btn-left'></div>
        <div className='bg-modal'>
          <div className="dailog-max-btn ">

            <button className="btn" onClick={() => setMapVisible(false)}>
              <img src={CloseCollapse} alt="Collapse" />
            </button>
          </div>
        </div>
      </Dialog>

      <section style={{ position: 'relative', marginTop: '4em' }} >
        <div className="tab-home mt-5 container">
          <div className="d-flex align-items-center justify-content-between flex-mob-col flex-align">
            <h1
              className="text-2xl font-bold leading-10"
              style={{ borderBottom: '2px solid #00A14B' }}
            >
              شعبه های ما
            </h1>
          </div>
          <div className="branch-grid">
            {currentItems.map((item) => (
              <div className="branch-card" key={item.id}>
                <div className="shadow-md rounded-2xl overflow-hidden animation">
                  <div
                    className="aspect-[3/3] overflow-hidden flex items-center justify-center"
                    onClick={() => openDialog(item)}
                  >
                    <img
                      src={getDefaultImage(item.images)}
                      alt={item.title || 'Branch'}
                    />
                  </div>
                  <div className="p-2">
                    <div className="font-bold text-lg " onClick={() => openDialog(item)}>
                      {item.title || 'Branch Name'}
                    </div>
                    <div
                      className="text-sm text-[#ADADAD] mt-2 address-field"
                      onClick={() => openDialog(item)}
                    >
                      {item.addres || 'Branch address'}
                    </div>
                    <div className="flex gap-1 justify-end mt-2">
                      <button
                        onClick={() => openMapDialog(item.lat, item.long, item.addres)}
                        className="rounded-[100%] button-branch bg-[#00A14B] p-1 w-8 h-8 animation"
                      >
                        <img src={LocationIcon} alt="Location" />
                      </button>
                      <button
                        className="rounded-[100%] bg-[#00A14B] p-1 w-8 h-8 button-branch animation"
                        onClick={() => openDialog(item)}
                      >
                        <img src={CollapseIcon} alt="Details" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* 
        

          {/* Paginator */}
          <Paginator className='mt-5 px-0' pageLinkSize={3} first={first} rows={rows} totalRecords={total} onPageChange={onPageChange} />

        </div>
      </section>
    </div>
  );
};

export default Branches;
